import React, { Suspense } from 'react';
import {createRoot} from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';

// import { loadStripe } from '@stripe/stripe-js';
// import { Elements } from '@stripe/react-stripe-js';
import * as serviceWorker from './serviceWorker';
import store from './app/store';
import App from './App';
import { sentryUrl } from './config/config';
import { spinner } from './components/Layout/Spinner/Spinner';
import './i18n';
import { nettoyer } from './masquer-evenement';

// const stripePromise = loadStripe(stripe.publicApiKEy);

const environment = import.meta.env.MODE || 'production';

if (environment !== 'development') {
  Sentry.init({
    dsn: sentryUrl,
    environment,
    // ⚠️ Incapable de lever : si `beforeSend` échoue, le SDK jette
    // l'événement, et la panne de la protection serait la disparition de
    // toutes les alertes.
    beforeSend(event) {
      try {
        return nettoyer(event);
      } catch (e) {
        return {
          message:
            "Événement supprimé par beforeSend : le nettoyage a échoué, et le "
            + "contenu d'origine a été jeté plutôt que transmis non masqué.",
          level: 'error',
        };
      }
    },
  });
}

// store.dispatch(verifyAuth(firebase));

// React 18 a remplacé « ReactDOM.render » par « createRoot ». Ce n'est pas
// qu'un renommage : la nouvelle racine active le rendu concurrent, qui est ce
// que React 19 attend.
//
// ⚠️ « StrictMode » reste commenté, comme il l'était. Il monte chaque composant
// DEUX FOIS en développement pour débusquer les effets non idempotents — c'est
// utile, mais ça mérite d'être activé délibérément, en regardant ce que ça
// révèle, pas au détour d'une migration.
createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <Suspense fallback={spinner}>
        {/* <Elements stripe={stripePromise}> */}
        <App />
        {/* </Elements> */}
      </Suspense>
    </BrowserRouter>
  </Provider>,
  // </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
